import { render } from "./CheckerAdd.vue?vue&type=template&id=1b669eb8"
import script from "./CheckerAdd.vue?vue&type=script&lang=js"
export * from "./CheckerAdd.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__